/**
 * Executes nothing.
 */
const noop = () => {};

export default noop;